import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useLanguage } from '../contexts/LanguageContext';

export const FAQ = () => {
  const { t } = useLanguage();
  const faqItems = t('faq.items');

  return (
    <section className="faq-section">
      <div className="container-custom">
        <div className="faq-content">
          <div className="faq-header">
            <div className="section-badge">{t('faq.badge')}</div>
            <h2 className="section-title">{t('faq.title')}</h2>
            <p className="section-description">{t('faq.description')}</p>
          </div>

          <Accordion type="single" collapsible className="faq-accordion">
            {Array.isArray(faqItems) && faqItems.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="faq-item">
                <AccordionTrigger className="faq-question">{faq.q}</AccordionTrigger>
                <AccordionContent className="faq-answer">{faq.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="faq-footer">
            <div className="faq-footer-content">
              <h3>{t('faq.stillHaveQuestions')}</h3>
              <p>{t('faq.contactHelp')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
